export default {
  TOOLBAR_EDITING_SIZE: 'ad465342-d69f-4d0a-9a68-7df8c5149ea5',
};
